"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    text = _ref$palette.text,
    error = _ref$palette.error,
    spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    root: {
      fontFamily: typography.fontFamily,
      fontSize: '16px',
      lineHeight: '22px'
    },
    modal: function modal(props) {
      return {
        padding: '0px',
        width: props.width ? props.width : 'auto'
      };
    },
    closeButton: {
      position: 'absolute',
      right: 10,
      top: 10,
      width: '3rem',
      color: '#c3c3c3'
    },
    title: {
      fontWeight: typography.fontWeightSemiBold,
      color: text.primary,
      fontSize: '18px',
      lineHeight: '27px',
      margin: '0px'
    },
    content: {
      borderBottom: '#f7f7f7 solid 1px',
      padding: '16px 24px',
      color: '#212529',
      fontSize: '13px'
    },
    buttons: {
      padding: '16px 24px',
      display: 'flex',
      '& button': {
        marginLeft: '8px',
        textTransform: 'none',
        fontWeight: 400,
        '&:first-child': {
          marginLeft: 0
        }
      }
    },
    exitButton: {
      color: text.primary
    },
    confirmButton: {
      color: '#D55E5E',
      fontSize: '13px',
      fontWeight: 400,
      backgroundColor: 'rgba(213, 94, 94, 0.10)',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: (0, _styles.darken)('#D55E5E', 0.4)
      }
    },
    cancelButton: function cancelButton(props) {
      return {
        background: props.actionModal ? 'rgba(213, 94, 94, 0.10)' : '#F7F7F7',
        boxShadow: 'none',
        color: props.actionModal ? '#D55E5E' : ''
      };
    }
  };
}, {
  name: 'ConfirmationModal'
});
exports.useStyles = useStyles;